import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { hubInvoiceNumberForDisplay } from "@integrator-src/commissions/qbo-payment-invoice-link";
import { HoverHintTrigger } from "@/components/ui/title-help";
import { buildShippingGosiDetailsPath } from "@/lib/hubEntityDetailPaths";
import { cn } from "@/lib/utils";

import {
  InvoiceDetailHoverHint,
  type InvoiceDetailPeekContext,
} from "./InvoiceDetailHoverHint";

const DETAIL_LINK_CLASS =
  "font-medium text-sky-700 hover:text-sky-900 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-1";

export function InvoiceDetailLink({
  invoiceMvId,
  invoiceNumber,
  peek,
  className,
  children,
  block = false,
}: {
  invoiceMvId: number | null | undefined;
  invoiceNumber?: string | null;
  peek?: InvoiceDetailPeekContext;
  className?: string;
  children?: ReactNode;
  block?: boolean;
}): ReactNode {
  const displayNumber = hubInvoiceNumberForDisplay(invoiceNumber);
  const label = children ?? (displayNumber !== "" ? displayNumber : "—");
  if (invoiceMvId == null || !Number.isFinite(invoiceMvId) || invoiceMvId <= 0) {
    return <span className={className}>{label}</span>;
  }

  const link = (
    <Link
      to={buildShippingGosiDetailsPath(invoiceMvId)}
      className={cn(DETAIL_LINK_CLASS, block ? "block truncate" : undefined, className)}
    >
      {label}
    </Link>
  );

  if (peek == null) {
    return link;
  }

  return (
    <HoverHintTrigger block={block} align="start" trigger={link}>
      <InvoiceDetailHoverHint context={peek} />
    </HoverHintTrigger>
  );
}
